import { render, staticRenderFns } from "./MenuSubItem.vue?vue&type=template&id=53dcaba8&"
import script from "./MenuSubItem.vue?vue&type=script&lang=js&"
export * from "./MenuSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports